import * as React from 'react';
import Modal from 'react-modal';

interface Props {
    callback: <T = null>(args?: T) => void
}

interface State {
    open: boolean
    status: number
}

class ReloadReportModal extends React.Component<Props, State> {
    state = {
        open: false,
        status: 12,
    }

    public show = (event: React.MouseEvent<HTMLButtonElement>, status) => {
        if (event) {
            event.preventDefault();
        }

        this.setState({open: true, status})
    };

    public onClose = (event?: React.MouseEvent<HTMLButtonElement>): void => {
        if (event) {
            event.preventDefault();
        }
        this.setState({open: false});
    }

    onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const { status } = this.state

        this.onClose();
        this.props.callback({ status })
    }

    render() {
        const { open, status } = this.state;

        const reportNumber = {
            12: 1,
            14: 2
        }[status]

        return (
            <Modal isOpen={open} ariaHideApp={false}
                   className='react-bs-insert-modal modal-dialog'
                   contentLabel='Modal'>
                <form className="modal-content react-bs-table-insert-modal" onSubmit={this.onSubmit}>
                    <div className="modal-header">
                        <button type="button" className="close" onClick={this.onClose}>
                            <span aria-hidden="true">×</span>
                        </button>
                        <h4 className="modal-title">Заполнить отчет заново</h4>
                    </div>
                    <div className="modal-body">
                        Вы действительно хотите начать заполнение Отчёта №{reportNumber} заново?
                    </div>
                    <div className="modal-footer">
                        <button type="submit" className="btn btn-primary">OK</button>
                        <button type="button" className="btn btn-default btn-secondary" onClick={this.onClose}>Отмена</button>
                    </div>
                </form>
            </Modal>
        );
    }
}
export default ReloadReportModal;


// WEBPACK FOOTER //
// ./src/components/request/ReloadReportModal.tsx